<template>
  <div id="mian">
    <div class="desc">
      <h5 class="jsxx">店铺免审模式</h5>
    </div>
    <div class="tab1">
      <table class="tab">
        <tr class="tab_title">
          <td>
            <p>进件频率(秒/次)</p> 
          </td>
          <td>
            <p>冻结时间（秒）</p>
          </td>
					<td style="width:25%">
					  <p>激活状态</p>
					</td>
          <td>
            <p>操作</p>
          </td>
        </tr>
        <tr>
          <td>
            <p>{{storeConfig.applyFrequency}}</p>
          </td>
          <td>
            <p>{{storeConfig.frozenFrequency}}</p>
          </td>
					<td>
						<p>
							<el-switch v-model="storeConfig.activateStatus" @change="setStatus" active-color="#13ce66">
							</el-switch>
						</p>
					</td>
          <td>
            <p><i class="lianjie" @click="onShow()">编辑</i></p>
          </td>
        </tr>
      </table>
    </div>
    <div class="btn">
        <el-button @click="entryConfigBack" class="back">返回</el-button>
      </div>
    <el-dialog title="店铺免审模式" :visible.sync="userPayShow" width="490px">
      <ul class="overAccount_ul">
        <li class="ul_left">
          <div class="overAccount_ul_title">进件频率(s/次)</div>
          <el-input min="0" v-model="storeForm.applyFrequency" type="number" onKeypress="return(/[\d.]/.test(String.fromCharCode(event.keyCode)))" placeholder="输入进件频率"></el-input>
        </li>
        <li class="ul-right">
          <div class="overAccount_ul_title">冻结时间(s)</div>
          <el-input min="0" v-model="storeForm.frozenFrequency" type="number"  onKeypress="return(/[\d.]/.test(String.fromCharCode(event.keyCode)))" placeholder="输入冻结时间"></el-input>
        </li>
      </ul>
      <span slot="footer" class="dialog-footer">
        <el-button class="exitBt" @click="userPayShow = false">取 消</el-button>
        <el-button class="addBt" @click="onsubmit">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
	import {
		getConfig,
		setConfig
	} from '@/api/management/index.js'
  export default {
    data() {
      return {
				storeConfig:'',
				storeForm:'',
        userPayShow: false, //店铺免审
        // OFFON_EDIT: 'SYSTEM:GLOBAL_CONFIG/EDIT',
      };
    },
		created() {
			this.getDetail();
      // this.listJurisdiction();
		},
    methods: {
			getDetail(){
				getConfig().then(res=>{
					if(res.resultStatus){
						this.storeConfig = res.resultData.storeConfig
					}
				})
			},
			onShow(){
				this.storeForm = JSON.parse(JSON.stringify(this.storeConfig))
        this.userPayShow = true
			},
			// 激活状态修改
			setStatus(){
        this.$confirm('此操作将修改状态, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          let data = {
            storeConfig: this.storeConfig,
          }
          setConfig(data).then(res=>{
            if(!res.resultStatus){
              this.storeConfig.activateStatus = this.storeConfig.activateStatus?false:true
            }
          })
        }).catch(() => {
					this.storeConfig.activateStatus = this.storeConfig.activateStatus?false:true
          this.$message({
            type: 'info',
            message: '已取消操作'
          });
        });
			},
			onsubmit(){
				if( !/^[0-9]+$/.test(this.storeForm.applyFrequency)){
					this.$message.error('请输入正确的进件频率')
					return
				}
				if( !/^[0-9]+$/.test(this.storeForm.frozenFrequency)){
					this.$message.error('请输入正确的冻结时间')
					return
				}
				let data = {
					storeConfig: this.storeForm,
				}
				setConfig(data).then(res=>{
					if(res.resultStatus){
            this.$message.success('保存成功')
						this.getDetail()
						this.userPayShow = false
					}
				})
			},
      // 返回
      entryConfigBack(){
        this.$router.push({
          name: "shoplist_mdlb",
        });
      },
      //判断列表按钮是否有权限
      listJurisdiction(){
          const _resources = JSON.parse(sessionStorage.getItem('userInfo')).resources;
          if(_resources=='ALL'){
              this.OFFON_EDIT = 'SYSTEM:GLOBAL_CONFIG/EDIT';
          }else{
            if(_resources.split(';').indexOf('SYSTEM:GLOBAL_CONFIG/EDIT') !== -1 ){
              this.OFFON_EDIT = 'SYSTEM:GLOBAL_CONFIG/EDIT';
            }else{
              this.OFFON_EDIT = "";
            }
          }

      },
    }
  }
</script>
<style scoped>
 @import "../../../../assets/css/desc.css";
.tab1{
  min-height: auto !important;
}   
  .next {
    width: 120px;
    height: 32px;
    background: rgba(72, 184, 182, 1);
    border-color: #5AAFAB;
    border-radius: 3px;
    line-height: 10px;
    margin-left: 10px;
    padding: 0;
    font-size: 12px;
  }

  .back {
    width: 120px;
    line-height: 10px;
    height: 32px;
    background: rgba(255, 255, 255, 1);
    border: 1px solid #DCE0E6;
    border-radius: 3px;
    padding: 0;
    font-size: 12px;
    color: #333333;
  }

  .btn {
    width: 100%;
    text-align: center;
    height: 33px;
    margin-top: 50px;
    margin-bottom: 18px;
  }

  .overAccount_ul {
    overflow: hidden;
  }

  .overAccount_ul_title {
    height: 36px;
    font-size: 14px;
    line-height: 36px;
    color: #999999;
    text-align: left;
  }

  .overAccount_ul .el-input,
  .overAccount_ul .el-select {
    margin-bottom: 7px;
  }

  .overAccount_ul .ul_left {
    float: left;
    width: 200px;
    margin-left: 24px;
  }

  .overAccount_ul .ul-right {
    float: right;
    width: 200px;
    margin-right: 26px;
  }

  .addBt {
    width: 60px;
    height: 32px;
    background-color: #48B8B6;
    border-color: #5AAFAB;
    color: #FFFFFF;
    font-size: 12px;
    padding: 0;
  }

  .exitBt {
    width: 60px;
    height: 32px;
    background-color: #ffffff;
    border-color: #DCE0E6;
    color: #333333;
    font-size: 12px;
    padding: 0;
  }
  .secret-key{
    display: flex;
    justify-content: center;
  }
  .btn {
  width: 100%;
  text-align: center;
  height: 33px;
  margin-top: 50px;
  margin-bottom: 18px;
}
</style>
